module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/VA-98be193fd5e290b79f13802098caa5ac.png";